import { useAppSelector } from '@store';
import { ButtonSecondary, SidePanel, SidePanelType } from '@ui/src';
import { TopUpPanelTypes } from './types';
import useTopUpPanel from './hooks/use-top-up-panel';
import OverviewTopupSidepanel from '../../../components/common/top-up/panel';

const TopUpPanel = ({
  topUpPanelIsOpen,
  setTopUpPanelIsOpen,
  selectedTopUpId,
  setSelectedTopUpId,
  userAccounts,
  setSelectedAccount,
  selectedAccount,
}: TopUpPanelTypes) => {
  const {
    topUpInstrusctions,
    topUpOptions: topUpOptionsValues,
    topUpOptionsPagination,
  } = useAppSelector((state) => state.topUpPanel);
  const { currenciesList: currencies, paymentTypes } = useAppSelector(
    (state) => state.root,
  );

  const {
    handleCloseTopUpSidepanel,
    topUpOptions,
    topUpCurrency,
    setTopUpCurrency,
    topUpAccount,
    setTopUpAccount,
    instructionsIsLoading,
    instructionsIsFetching,
    getCustomersTopUpInstructionPdfAction,
    pdfDownloadInProgress,
    selectedInstructionType,
    onSearchTopUp,
    isLoading,
    isFetching,
    nextPageIsLoading,
    searchText,
    setSearchText,
  } = useTopUpPanel({
    topUpOptionsValues,
    selectedTopUpId,
    userAccounts,
    setSelectedTopUpId,
    setTopUpPanelIsOpen,
    setSelectedAccount,
    topUpPanelIsOpen,
    selectedAccount,
  });

  return (
    <SidePanel
      type={SidePanelType.Customers}
      closeOnClickOutside
      isOpen={topUpPanelIsOpen}
      onClose={handleCloseTopUpSidepanel}
      title="Download Top-up options"
      footer={
        <ButtonSecondary
          text="Cancel"
          onClick={handleCloseTopUpSidepanel}
          className="button-white"
          bold
        />
      }
      sidepanelExpandedKey="customers-accounts-statements"
    >
      <OverviewTopupSidepanel
        selectedTopUpId={selectedTopUpId}
        setSelectedTopUpId={setSelectedTopUpId}
        topUpOptions={topUpOptions}
        topUpCurrency={topUpCurrency}
        setTopUpCurrency={setTopUpCurrency}
        currencies={currencies}
        topUpAccount={topUpAccount}
        setTopUpAccount={setTopUpAccount}
        topUpAccounts={userAccounts}
        instructionsIsLoading={instructionsIsLoading || instructionsIsFetching}
        topUpInstrusctions={topUpInstrusctions}
        getTopUpInstructionPdf={getCustomersTopUpInstructionPdfAction}
        pdfDownloadInProgress={pdfDownloadInProgress}
        selectedInstructionType={selectedInstructionType}
        onSearchTopUp={onSearchTopUp}
        searchInProgress={isLoading || isFetching}
        nextPageIsLoading={nextPageIsLoading}
        searchText={searchText}
        setSearchText={setSearchText}
        topUpOptionsPagination={topUpOptionsPagination}
        paymentTypes={paymentTypes}
      />
    </SidePanel>
  );
};

export default TopUpPanel;
